// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Actualités
export default class Actualite  {
  // Identifiant unique
  public id: number;
  // Label de l'actualité
  public label: string;
  // Image
  public image: string;
  // Titre de l'actualité
  public title: string;
  // Description de l'actualité
  public description: string;
  // Description courte
  public shortDescription: string;
  // URL externe
  public url: string;
  // Titre de l'actualité
  public titleHtmlId: number;
  // Description de l'actualité
  public descriptionHtmlId: number;
  // Description courte
  public shortDescriptionHtmlId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.label = '';
    this.image = '';
    this.title = '';
    this.description = '';
    this.shortDescription = '';
    this.url = '';
    this.titleHtmlId = 0;
    this.descriptionHtmlId = 0;
    this.shortDescriptionHtmlId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Actualite): Actualite {
    const newActualite: Actualite = new Actualite();
    newActualite.id = obj.id;
    newActualite.label = obj.label;
    newActualite.image = obj.image;
    newActualite.title = obj.title;
    newActualite.description = obj.description;
    newActualite.shortDescription = obj.shortDescription;
    newActualite.url = obj.url;
    newActualite.titleHtmlId = obj.titleHtmlId;
    newActualite.descriptionHtmlId = obj.descriptionHtmlId;
    newActualite.shortDescriptionHtmlId = obj.shortDescriptionHtmlId;
    newActualite.createId = obj.createId;
    newActualite.failed = obj.failed;
    newActualite.canUpdate = obj.canUpdate;
    newActualite.canDelete = obj.canDelete;
    newActualite.display = obj.display;
    newActualite.notifDefType = obj.notifDefType;
    return newActualite;
  }

  public toJsonActualite (): string {
    const json = {
      label: this.label,
      image: this.image,
      title: this.title,
      description: this.description,
      shortDescription: this.shortDescription,
      url: this.url,
      titleHtmlId: this.titleHtmlId,
      descriptionHtmlId: this.descriptionHtmlId,
      shortDescriptionHtmlId: this.shortDescriptionHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromActualite (obj: Actualite): void {
    this.id = obj.id;
    this.label = obj.label;
    this.image = obj.image;
    this.title = obj.title;
    this.description = obj.description;
    this.shortDescription = obj.shortDescription;
    this.url = obj.url;
    this.titleHtmlId = obj.titleHtmlId;
    this.descriptionHtmlId = obj.descriptionHtmlId;
    this.shortDescriptionHtmlId = obj.shortDescriptionHtmlId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareActualite (value: Actualite): boolean {
    return (this.toJsonActualite() == value.toJsonActualite());
  }

  public cloneActualite (): Actualite {
    return Actualite.fromJson(this);
  }

  public createForStoreActualite (): Promise<Actualite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/actualites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromActualite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreActualite (): Promise<Actualite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/actualites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromActualite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreActualite (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/actualites/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/actualites/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Actualites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Actualite.fromJson(listData.reccords[0] as Actualite);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Actualite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Actualites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Actualite.fromJson(listData.reccords[0] as Actualite);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(actualites: Actualite[]) {
  }
}
